import { Formik, Form } from 'formik';
import { ReactElement } from 'react';
/**
 * Formik-based wrapper component for easily creating forms.
 * If `props.children` are passed as a function, "render props" will be used
 * @param {*} props
 * @returns {ReactElement} Formik form wrapped around `props.children`
 */
const FormWrapper = props => {
	const form = (
		<>
			<Formik {...props}>
				{formik => (
					<Form
						onKeyDown={e => {
							if (e.key === 'Enter') {
								formik.submitForm();
								e.preventDefault();
							}
						}}
					>
						{props.children && typeof props.children === 'function'
							? props.children({ formik: formik })
							: props.children}
					</Form>
				)}
			</Formik>
		</>
	);

	return form;
};

export default FormWrapper;
